import React from 'react';
import PropTypes from 'prop-types';

import DomainButton from 'components/DomainButton';
import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import withStyles from '@material-ui/core/styles/withStyles';

const styles = theme => {
  return {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    header: {
      fontSize: 50.9,
      color: theme.palette.primary.main,
      marginTop: theme.spacing(9),
      [theme.breakpoints.down('xs')]: {
        fontSize: 30.9,
        marginTop: theme.spacing(2),
      },
    },
    subheader: {
      color: theme.palette.common.black,
      fontSize: 17,
    },
    button: {
      marginTop: theme.spacing(3),
      color: theme.palette.secondary.dark,
    },
    buttonContainer: {
      marginTop: theme.spacing(3),
      display: 'block',
      width: 430,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      [theme.breakpoints.down('xs')]: {
        width: '90%',
      },
    },
  };
};

class DomainSelector extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    loginDomains: PropTypes.array.isRequired,
    email: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (this.props.loginDomains.length === 0) {
      this.props.history.push(`/`);
    }
  }

  render() {
    const { classes, loginDomains, email, history } = this.props;
    return (
      <SplitPageContainer>
        <SplitPageRight>
          <Typography className={classes.header} variant="h2">
            Select a Sift Domain
          </Typography>
          <Typography className={classes.subheader} variant="body1">
            {email}
          </Typography>
          <div className={classes.buttonContainer}>
            {loginDomains.map((loginOptionResponse, index) => (
              <DomainButton
                key={index}
                loginOptionResponseIndex={index}
                history={history}
                loginOptionResponse={loginOptionResponse}
              />
            ))}
          </div>
          <Button className={classes.button} onClick={history.goBack}>
            Back
          </Button>
        </SplitPageRight>
      </SplitPageContainer>
    );
  }
}

export default withStyles(styles)(DomainSelector);
